module.exports = __webpack_public_path__ + "img/backhoe_parked.4fca9bc1.svg";